import { render, staticRenderFns } from "./schoolProject.vue?vue&type=template&id=030b47d8&"
import script from "./schoolProject.vue?vue&type=script&lang=js&"
export * from "./schoolProject.vue?vue&type=script&lang=js&"
import style0 from "./schoolProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports